import React from "react";
import { CheckCircle2, BadgeCheck, ShieldCheck, Clock, IndianRupee, ArrowRight } from "lucide-react";
import { aboutFeatures, whyChooseUs, aboutImage } from "../mock";

const iconMap = { BadgeCheck, ShieldCheck, Clock, IndianRupee };

const About = ({ onQuote }) => {
  return (
    <section id="about" className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-stretch">
          {/* Image */}
          <div className="lg:col-span-4">
            <div className="h-full rounded-2xl overflow-hidden shadow-xl">
              <img src={aboutImage} alt="Transformer" className="w-full h-full object-cover" />
            </div>
          </div>

          {/* Text */}
          <div className="lg:col-span-4">
            <p className="text-[#F5B800] font-semibold tracking-widest text-sm uppercase">About Us</p>
            <h2 className="mt-1 text-3xl md:text-4xl font-extrabold text-[#0f2a5c] underline-yellow-left">
              Brahma Electrical
            </h2>
            <p className="mt-6 text-slate-600 leading-relaxed text-[15px]">
              We are a trusted electrical contracting and solar solutions company based in Sillod, Chhatrapati Sambhajinagar. Our mission is to deliver safe, efficient and cost-effective solutions with the highest standards of quality.
            </p>

            <ul className="mt-6 space-y-3">
              {aboutFeatures.map((f) => (
                <li key={f} className="flex items-center gap-3 text-[15px] text-slate-700">
                  <CheckCircle2 className="w-5 h-5 text-[#0f2a5c]" fill="#F5B800" />
                  <span>{f}</span>
                </li>
              ))}
            </ul>

            <button
              onClick={onQuote}
              className="mt-7 inline-flex items-center gap-2 bg-[#F5B800] hover:bg-[#e0a800] text-[#0f2a5c] font-semibold px-6 py-3 rounded-md transition-colors shadow-md"
            >
              Know More About Us <ArrowRight className="w-4 h-4" />
            </button>
          </div>

          {/* Why Choose Us */}
          <div id="why" className="lg:col-span-4">
            <div className="h-full bg-[#eef2fb] rounded-2xl p-7">
              <h3 className="text-2xl font-extrabold text-[#0f2a5c]">Why Choose Us?</h3>
              <div className="mt-5 space-y-5">
                {whyChooseUs.map((w) => {
                  const Icon = iconMap[w.icon];
                  return (
                    <div key={w.id} className="flex items-start gap-4">
                      <div className="w-11 h-11 rounded-lg bg-white flex items-center justify-center shadow-sm flex-shrink-0">
                        <Icon className="w-5 h-5 text-[#0f2a5c]" />
                      </div>
                      <div>
                        <div className="font-semibold text-[#0f2a5c]">{w.title}</div>
                        <div className="text-sm text-slate-600 mt-0.5">{w.description}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
